<script lang="ts" setup>
defineProps<{
  items: {
    title: string;
    image: string;
    href?: string;
    target?: string;
    description?: string;
    contenu?: {
      nom: string;
      document: string;
    }[];
  }[];
  title?: string;
  description?: string;
  innerClass?: string;
}>();

function onSelect(event: Event) {
  const value = (event.target as HTMLSelectElement).value;
  if (!value) return;

  window.open(value, "_blank");
}
</script>

<template>
  <SectionHeader :title="title" :description="description" />
  <div :class="innerClass">
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
      <template
        v-for="(item, index) in items"
        :key="index"
      >
        <div class="text-center flex flex-col h-full mb-1">
          <!-- Image -->
          <div class="flex items-center justify-center h-[420px]">
            <img
              :src="item.image"
              :alt="item.title"
              class="max-h-full object-contain"
            >
          </div>

          <!-- Titre -->
          <h4 class="heading-5 font-black mt-4">
            {{ item.title }}
          </h4>

          <!-- Select toujours présent -->
          <div class="mt-4">
            <select
              class="border p-2 w-full"
              @change="onSelect"
            >
              <option value="">
                Télécharger un document
              </option>

              <option
                v-for="(doc, i) in item.contenu || []"
                :key="i"
                :value="doc.document"
              >
                {{ doc.nom }}
              </option>
            </select>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
